<template>
  <div class="container-fluid pg_module inst_signin">

    <div class="row top-bar" v-if="institutionMeta">
      <div class="col-12">
        <div class="row header">
          <div class="col-4"></div>
          <div class="col-4 logo_container">
            <template v-if="institutionMeta.logoUrl">
              <img class="logo ace_sec" :src="logoUrl" alt="institutionMeta logo">
            </template>
            <template v-else>
              <h3>{{institutionMeta.title}}</h3>
            </template>
          </div>
          <div class="col-3">
            <div class="d-none" v-if="institutionMeta.fontFamily">
              <font-picker :api-key="apiKey" :active-font="institutionMeta.fontFamily" :options="{name: 'srf'}"></font-picker>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="row page_content create-section apply-font-srf">
      <div class="content-section" v-if="institutionMeta" :style="{color: institutionMeta.backgroundColor}">
        <div class="inst_form_pg">

          <div class="row mb-3" v-if="institutionMeta.customText">
            <div class="col-12 p-2">
              <span v-html="institutionMeta.customText" ref="customText"></span>
            </div>
          </div>
          <template v-if="orgId">
            <div class="row fld_row">
              <div class="col-12 sec_hd">
                <span>Login to {{institutionMeta.title}} </span>
              </div>
            </div>
            <div class="row fld_row" style="margin-bottom: 0px;">
              <div class="col-12" id="validation-message">
                <div style="color: #ff0000; text-align: center;" v-html="errorMessage"></div>
              </div>
            </div>
            <div @keydown.enter="login">
              <div class="row fld_row">
                <div class="col-12 fld_label" id="userEmail">Email<sup>*</sup></div>
                <div class="col-12 fld_input">
                  <b-form-input type="email" v-model.email="eMail" :state="eMailState"
                    aria-labelledby="email" placeholder="Email" @input="forceEmailLowerCase($event)"
                    aria-describedby="eMailFeedback" style="width: 91%;">
                  </b-form-input>
                  <b-form-invalid-feedback id="eMailFeedback">
                    This is not a valid email
                  </b-form-invalid-feedback>
                </div>
              </div>
              <div class="row fld_row">
                <div class="col-12 fld_label" id="password">Password <sup>*</sup></div>
                <div class="col-12 fld_input">
                  <b-form-input type="password" v-model.trim="password" :state="passwordState"
                    aria-labelledby="password" placeholder="Password" @input="$v.password.$touch()"
                    aria-describedby="passwordFeedback" style="width: 91%;">
                  </b-form-input>
                  <b-form-invalid-feedback id="passwordFeedback">
                    Password should be 6 characters
                  </b-form-invalid-feedback>
                </div>
              </div>
              <div class="row fld_row">
                <div class="col-12 fld_label">
                  <div class="row">
                    <div class="col-8 lnk_container pt-2">
                      <a href="javascript:void(0)" @click="forgotPassword" :style="getLinkColor">Forgot password</a>
                    </div>
                    <div class="col-4 btn_container" style="padding-left: 1.5rem;">
                      <b-button size="lg" @click="login" class="apply-font-srf" :style="{'background-color': institutionMeta.primaryColor, color: institutionMeta.secondaryColor}">login</b-button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </template>
          <template v-else>
            <div class="row fld_row">
              <div class="col-12">
                <div class="text-center">
                  <h4>Self Signin Link is not valid. Please contact your administrator.</h4>
                </div>
              </div>
            </div>
          </template>
        </div>
      </div>
    </div>
    <div v-if="institutionMeta">
      <b-modal v-model="showForgotPasswordModal" title="Forgot Password" :header-bg-variant="'light'" :header-text-variant="'dark'" :footer-bg-variant="'light'" no-close-on-backdrop no-close-on-esc centered class="apply-font-srf forgot_password_modal">
        <div slot="modal-header" class="header-section w-100">
          <div class="row">
            <div class="col-10 popup_head_txt">
              <span :style="{color: institutionMeta.backgroundColor}">Forgot Password</span>
            </div>
            <div class="col-2 btn_container">
              <button class="btn_close" aria-label="close" @click="showForgotPasswordModal = false" :style="{color: institutionMeta.primaryColor}">
                <span class="ic-close"></span>
              </button>
            </div>
          </div>
        </div>
        <div class="inst_form_pg text-center" @keydown.enter="resetPassword">
          <template v-if="resetPasswordMessage">
            <span style="color: Red;">{{resetPasswordMessage}}</span>
          </template>
          <template v-else>
            <div class="row fld_row">
              <div class="col-12 fld_label">
                <div :style="{color: institutionMeta.backgroundColor}">User Email</div>
              </div>
              <div class="col-12 fld_input">
                <b-form-input type="email" v-model.email="resetPasswordEmail" :state="resetPasswordEmailState"
                  aria-labelledby="reset email" placeholder="Email" @blur.native="$v.resetPasswordEmail.$touch()"
                  aria-describedby="resetPasswordEmailFeedback" style="width: 96%;" :style="{color: institutionMeta.backgroundColor}">
                </b-form-input>
                <b-form-invalid-feedback id="resetPasswordEmailFeedback">
                  Please enter a proper email address.
                </b-form-invalid-feedback>
              </div>
            </div>
          </template>
        </div>
        <div slot="modal-footer" class="w-100">
          <div class="btn_container">
            <template v-if="resetPasswordMessage">
              <b-button variant="primary" size="sm" class="float-right apply-font-srf" @click="showForgotPasswordModal = false" :style="{'background-color': institutionMeta.primaryColor, color: institutionMeta.secondaryColor}">ok</b-button>
            </template>
            <template v-else>
              <b-button variant="primary" size="sm" class="float-right ml-3 apply-font-srf" @click="resetPassword" :style="{'background-color': institutionMeta.primaryColor, color: institutionMeta.secondaryColor}">get new password</b-button>
              <b-button variant="primary" size="sm" class="float-right apply-font-srf" @click="showForgotPasswordModal = false" :style="{'background-color': institutionMeta.primaryColor, color: institutionMeta.secondaryColor}">cancel</b-button>
            </template>
          </div>
        </div>
      </b-modal>
    </div>
  </div>
</template>

<script>
  import Vue from 'vue'
  import _ from 'lodash'
  import { mapActions } from 'vuex'
  import Vuelidate from 'vuelidate'
  import FontPicker from 'font-picker-vue'
  import {required, email, minLength} from 'vuelidate/lib/validators'
  Vue.use(Vuelidate)

  export default {
    name: 'institutionSignin',
    components: {
      'font-picker': FontPicker
    },
    data: () => {
      return {
        orgId: null,
        eMail: '',
        password: '',
        institutionMeta: null,
        roles: {role: 'Student'},
        errorMessage: '',
        showForgotPasswordModal: false,
        resetPasswordEmail: '',
        resetPasswordMessage: null,
        apiKey: 'AIzaSyAa3D-xZhJGxFRI2cxDX6iInTwA4hKy3pc'
      }
    },
    validations: {
      eMail: {
        required,
        email
      },
      password: {
        required,
        minLength: minLength(6)
      },
      resetPasswordEmail: {
        required,
        email
      }
    },
    created () {
      this.resetData()
      this.orgId = this.getQueryParamByName('orgId')
    },
    async mounted () {

      let utm_medium = this.getQueryParamByName('utm_medium')
      localStorage.setItem('utm_medium', utm_medium)
      let utm_source = this.getQueryParamByName('utm_source')
      localStorage.setItem('utm_source', utm_source)
      let utm_campaign = this.getQueryParamByName('utm_campaign')
      localStorage.setItem('utm_campaign', utm_campaign)
      let utm_content = this.getQueryParamByName('utm_content')
      localStorage.setItem('utm_content', utm_content)
      let utm_term = this.getQueryParamByName('utm_term')
      localStorage.setItem('utm_term', utm_term)

      this.institutionMeta = await this.loadInstitutionMetaInfoForSelfRegistration(this.orgId)
      let root = document.documentElement;
      root.style.setProperty("--TU__BaseTxtClr", this.institutionMeta.backgroundColor); // Other Text Color
      root.style.setProperty("--TU__BtnClrPri", this.institutionMeta.primaryColor); // Button Color
      root.style.setProperty("--TU__BtnTxtClrPri", this.institutionMeta.secondaryColor); // Button Text Color
      root.style.setProperty("--TU__BtnHoverClrPri", this.institutionMeta.buttonHoverColor); //Button Hover Color
      root.style.setProperty("--TU__BtnTxtHoverClrPri", this.institutionMeta.secondaryColor); // Button Text Color
      root.style.setProperty("--TU__BtnClrSec", this.institutionMeta.primaryColor); // Button Color
      root.style.setProperty("--TU__BtnHoverClrSec", this.institutionMeta.buttonHoverColor);  //Button Hover Color
      root.style.setProperty("--TU__LnkClrPri", this.institutionMeta.linkColor); // Link Color
      root.style.setProperty("--TU__LnkHoverClrPri", this.institutionMeta.linkHoverColor); // Link Hover Color
      root.style.setProperty("--TU__LnkClrSec", this.institutionMeta.backgroundColor); // Other Text Color
      root.style.setProperty("--TU__LnkHoverClrSec", this.institutionMeta.backgroundColor); // Other Text Color
      setTimeout(() => {
        this.updateCustomTextFontFamily()
      }, 1000)
    },
    computed: {
      eMailState () {
        return (this.eMail.length === 0) ? null : !this.$v.eMail.$error
      },
      passwordState () {
        return (this.password.length === 0) ? null : !this.$v.password.$error
      },
      resetPasswordEmailState () {
        return (this.resetPasswordEmail.length === 0) ? null : !this.$v.resetPasswordEmail.$error
      },
      enableLogin () {
        return (this.eMailState && this.passwordState && this.password.length >= 6)
      },
      logoUrl () {
        if (this.institutionMeta && this.institutionMeta.logoUrl) {
          return this.institutionMeta.logoUrl
        }
        return null
      },
      getLinkColor () {
        let color = '#157099'
        if (this.institutionMeta && this.institutionMeta.primaryColor) {
          color = this.institutionMeta.primaryColor
        }
        return {'color': color}
      }
    },
    methods: {
      ...mapActions([
        'loadInstitutionMetaInfoForSelfRegistration',
        'loadResetPassword',
        'loadUserLogin',
        'setUserInfo'
      ]),
      showLoader () {
        if (this.$parent.$refs.loadingModal) {
          this.$parent.$refs.loadingModal.show()
        }
      },
      hideLoader () {
        if (this.$parent.$refs.loadingModal) {
          this.$parent.$refs.loadingModal.hide()
        }
      },
      getQueryParamByName(name, url = window.location.href) {
        name = name.replace(/[\[\]]/g, '\\$&')
        let regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)')
        let results = regex.exec(decodeURIComponent(url))
        if (!results || !results[2]) return ''
        return results[2].replace(/\+/g, ' ')
      },
      forceEmailLowerCase (e) {
        e = e.trim().toLowerCase()
        this.$set(this.$data, 'eMail', e)
        this.$v.eMail.$touch()
      },
      resetData () {
        this.orgId = ''
        this.eMail = ''
        this.password = ''
        this.errorMessage = ''
      },
      login () {
        this.$v.eMail.$touch()
        this.$v.password.$touch()
        if (this.enableLogin) {
          this.showLoader()
          this.errorMessage = ''
          this.loadUserLogin({eMail: this.eMail, password: this.password, institutionId:this.institutionMeta.institutionId}).then(res => {
            let status = res.status
            let userObj = res.data
            if (status === 200) {
              this.hideLoader()
              let role = userObj.roles[0].role
              if (userObj.institutionId !== this.institutionMeta.institutionId) {
                this.errorMessage = '<b>' + this.eMail + '</b> does not exist in <b>' + this.institutionMeta.title + '</b>. Please contact your administrator.'
              }
              if (role !== this.roles.role) {
                this.errorMessage = 'You don\'t have a <b>Learner account</b> in <b>' + this.institutionMeta.title + '</b>. Please contact your administrator.'
              }

              if (!this.errorMessage || (this.errorMessage.length === 0)) {
                this.$parent.isInstitutionSignin = false
                if (!userObj.tnCAccepted) {
                    return this.$router.push({name: 'termsAndConditions', params: {userObj: userObj}})
                }
                return this.$router.push({name: 'dashboard'})
              }
            } else {
              this.hideLoader()
              switch (status) {
                case 503:
                  this.errorMessage = 'Server temporarily unavailable'
                  break
                case 401:
                  this.errorMessage = 'Invalid email or password'
                  break
                case 400:
                  this.errorMessage = 'Please enter all required fields'
                  break
                default:
                  this.errorMessage = 'Unexpected error code: ' + status
                  break
              }
            }
            if (this.errorMessage.length > 0) {
              $('#validation-message').fadeIn('fast')
            }
          })
        }
      },
      forgotPassword () {
        this.resetPasswordEmail = ''
        this.resetPasswordMessage = null
        this.showForgotPasswordModal = true
        this.$v.resetPasswordEmail.$touch()
      },
      resetPassword () {
        this.$v.resetPasswordEmail.$touch()
        if (this.resetPasswordEmailState) {
          this.loadResetPassword(this.resetPasswordEmail).then(res => {
            let status = res.status
            switch (status) {
              case 401:
                this.resetPasswordMessage = 'This email "' + this.resetPasswordEmail + '" does not exist.'
                break
              case 500:
                this.resetPasswordMessage = 'Error in service call.'
                break
              default:
                this.resetPasswordMessage = 'Please check your registered email for password reset instructions.'
                break
            }
          })
        }
      },
      updateCustomTextFontFamily () {
        if (this.institutionMeta) {
          let parentElem = this.$refs['customText']
          let elems = $(parentElem).find('*')
          _.forEach(elems, (elem) => {
            if ($(elem).css('font-family') !== null) {
              if (this.institutionMeta.fontFamily) {
                $(elem).css('font-family', 'inherit')
              }
            }
          })
        }
      }
    }
  }
</script>

<style scoped>
  .top-bar {
    height: 50px;
    padding-top: 0;
    background: #f5f5f5;
  }
  .content-section {
    float: left;
    width: 100%;
    margin-top: 25px;
    background: #f5f5f5;
    border: 1px solid #e3e3e3;
    padding: 20px;
    border-radius: 0;
  }
  .sec_hd {
    text-align: center;
    font-size: 17px;
    font-weight: 600;
    border-bottom: none;
  }
  .fld_row {
    margin-bottom: 15px;
  }
  .fld_label {
    text-align: left;
    padding-bottom: 5px;
    margin: auto;
    max-width: 450px;
  }
  .create-section .content-section sup {
    color: red;
    font-size: 17px;
    top: -2px;
    left: 2px;
  }
  .popup_head_txt {
    font-size: 1.1rem;
    width: 75%;
    color: #323232;
  }
</style>



// WEBPACK FOOTER //
// src/app/login/components/InstitutionSignin.vue